import { FlowStepRunner } from "../FlowStepRunner";
import { FlowExecutionData } from "../../Engine/FlowExecutionData";
import { FormStep } from "./FormStep";
import { IUserInfo } from "../../../Plugins/DataStorage/IUserInfo";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../Structure/FlowTestingContext";
import { FlowEngine } from "../../Engine/FlowEngine";

export class FormStepRunner extends FlowStepRunner<FormStep> {
    async start(
        _user: IUserInfo,
        _thread: string,
        _executionData: ExecutionData,
        _flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void> {
        // create and store assignment
        // see if form is assigned to current user
        // if so, suggest it to user

        // when form is complete.... call step complete
        await FlowEngine.stepComplete(_user, _flowExecutionData, _thread, this.stepData!, undefined, testContext);
    }
}
